// extracted by mini-css-extract-plugin
export default {"container":"UserManagement_container__H0d-L"};